/**
 * Convertit une URL de partage Google Drive (view?usp=sharing) en URL de flux direct
 * utilisable dans une balise <video>. Retourne l'URL originale sinon.
 *
 * Note : Google Drive bloque le streaming pour les fichiers > ~100 Mo (page de virus scan).
 * Recommandation : uploader directement via Emergent Object Storage.
 */
/**
 * Extrait l'ID d'une vidéo YouTube (watch, youtu.be, embed, shorts). Retourne null sinon.
 * Une URL YouTube ne peut pas être lue par une balise <video> (ce n'est pas un fichier
 * direct) : il faut la rendre via un <iframe> embed.
 */
export function getYouTubeId(url) {
  if (!url || typeof url !== "string") return null;
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  return m ? m[1] : null;
}

export function toStreamableVideoUrl(url) {
  if (!url || typeof url !== "string") return url;
  // Google Drive share/view URLs → direct download
  const m = url.match(/drive\.google\.com\/(?:file\/d\/([\w-]+)|open\?id=([\w-]+)|uc\?id=([\w-]+))/);
  if (m) {
    const id = m[1] || m[2] || m[3];
    return `https://drive.google.com/uc?export=download&id=${id}`;
  }
  // Dropbox share links → direct raw content
  if (url.includes("dropbox.com") && !url.includes("?raw=1") && !url.includes("dl=1")) {
    return url.replace("?dl=0", "?raw=1").split("?")[0] + "?raw=1";
  }
  return url;
}
